import React from "react";
export default function SiteFooter() {
    return (
        <footer id="site-footer">
            <div id="colophon">
                <p><small>This site is <a href="https://create-react-app.dev/" target="_blank" rel="noopener noreferrer">built with Create React App</a>.</small></p>
            </div>
            <a href="#top" title="Scroll to the top of the page"><svg id="arrow-up" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 22h-24l12-20z" /></svg></a>

        </footer>
    );
}


// WEBPACK FOOTER //
// ./src/components/SiteFooter.js